"use client"; 

import { useEffect, useState } from 'react'
import { FunnelIcon, MagnifyingGlassIcon } from '@heroicons/react/20/solid'

import FilterBubbles from '@/components/modules/generic/filterBubbles'
import ConnectionsList from '@/components/modules/appConnections/connectionsList'
import { classNames } from '@/lib/helpers'
import ConnectionsListItem from './connectionsListItem';
import SectionMoreButton from '../common/sectionMoreButton';


export default function AppConnectionsBlock({ 
  app, 
  appConnections, 
  appSources, 
  options 
}) {

  console.log(`Render AppConnectionsBlock.`)
  const { chunk } = options

  // FILTER PANEL SHOW/HIDE 
  const [showFilters, setShowFilters] = useState(false)

  // SEARCH TEXT   
  const [searchAppText, setSearchAppText] = useState('')

  // GLOBAL APPS LIST - Using SearchData
  const searchDataUrl =  `${process.env.NEXT_PUBLIC_NEXT_API_URL}/search/searchData?types=apps` 
  const [dataApps, setDataApps] = useState([])  
  useEffect(() => {
    (async () => {
      if (dataApps?.length === 0){
        try {
          // const searchDataUrl = `${process.env.DATA_API_URL}/api/search/searchData?types=apps` // http://localhost:3000/api/search/searchData?types=apps          
          const resp = await fetch(searchDataUrl, { cache: 'force-cache' } );
          const searchData = await resp.json();
          const { apps=[] } = searchData
          setDataApps(apps);  
        } catch {}
    }
    })();  
  }, [searchAppText]);
  
  const [selectedCategory, setSelectedCategory] = useState<any>(null)
  const [selectedSource, setSelectedSource] = useState<any>(null)

  // FILTER CONNECTIONS
  // TODO - recalc filters when Text Changes? 
  const filterCategories = getFilterCategories(appConnections)
  const filterSources = getFilterSources(appConnections, appSources, selectedCategory)  // taking into account chosen categories
  const filteredByCategoryCount = filterAppConnectionsByCategory(appConnections, selectedCategory)?.length // sh
  
  // Filter appConnections
  const appConnectionsFiltered = filterAppConnections(
      appConnections, 
      selectedCategory, 
      selectedSource, 
      searchAppText, 
      dataApps
    )
  
  const appConnectionsItems = getAppConnectionsItems(
    app, 
    appConnectionsFiltered, 
    dataApps, 
    searchAppText, 
    selectedCategory, 
    { chunk }
    )


  const [page, setPage] = useState(1)  // Using to load more apps
  const itemsVisible = appConnectionsItems?.slice(0, page*chunk)

  const showFoundText = selectedCategory?.id || selectedSource?.id || searchAppText

  const showFIlters = true  // Now with synthetic integrations we show 


  return (
    <>
      {/* <div className="bg-crisp-200 p-9">
        <p>{JSON.stringify(dataApps?.length)}</p>
        <p>{JSON.stringify(dataApps[0])}</p>        
      </div> */}


      {/* Connections filters - by category and by source */}
      <div className={classNames(showFilters ? 
        " border-crisp-600/50" : " border-gray-200" , 
        "rounded bg-gray-100 border")}>
        

        {/* Show/Hide Filters button and Input Search  */}
        <div className="p-2 space-x-3 flex items-center justify-between ">
          
          <div className="flex">
            <button
              type="button"
              onClick={ () => setShowFilters(!showFilters) }
              className={classNames(true ? '' : '', 
                "relative inline-flex items-center px-4 py-2 \
                rounded border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 \
                focus:outline-none")}
            >
              <FunnelIcon className="-ml-1 mr-2 h-5 w-5 text-gray-400" aria-hidden="true" />
              <span>{showFilters ? 'Hide' : 'Show'}</span>
              &nbsp;
              <span className="hidden sm:flex">
                Filters
              </span>
            </button> 
          </div>


          <div className="min-w-0 flex-1">
            <div className=" relative flex items-stretch flex-grow">
              
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
              </div>

              <input
                name="search_app_connections"
                id="search_app_connections"
                className="block w-full pl-10 pr-3 py-2 text-sm border border-gray-300 rounded leading-5 bg-white shadow-sm placeholder-gray-500 
                focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-crisp-600 focus:border-crisp-600 " 
                placeholder={`Integrate ${app?.name} with ...`}              
                onChange={(e) => { 
                  setSearchAppText(e.target.value) 
                }}
                onClick={ () => {} }
              />
            </div>
          </div>

        </div>

        {/* Filter Bubbles */}
        <div className={showFilters ? `` : `hidden`}>
          <div className="">
            {/* border-b border-gray-200 */}
            <FilterBubbles 
              items={filterCategories} 
              selectedItem={selectedCategory} 
              setSelectedItem={setSelectedCategory}             
              filterTitle='' 
              chunk={20}
              chunkInitial={4}
              itemAll = {{ 
                name: 'All Categories', 
                slug: 'all', 
                count: appConnections?.length 
              }}
            />
          </div>
          
          <div className="">
            <FilterBubbles 
              items={filterSources} 
              selectedItem={selectedSource} 
              setSelectedItem={setSelectedSource}             
              filterTitle='' 
              chunk={10}
              chunkInitial={4}
              itemAll = {{ 
                name: 'All Platforms', 
                slug: 'all', 
                count: filteredByCategoryCount 
              }}
            />     
          </div>     
        </div>
        
        {/* Fond X sentence */}
        {showFoundText ? (
          <p className="px-2 pb-2 text-gray-500 text-xs font-semibold">
            Found {appConnectionsItems?.length} {` `}
            {selectedCategory?.name ? `from ${selectedCategory?.name}` : ``}{` `}
            {selectedSource?.name ? `via ${selectedSource?.name}` : ``}{` `}
          </p>
        ) : null}

      </div>


      {itemsVisible?.map((item, index) => (
        <div key={index} >
          <ConnectionsListItem item={item} tag="h2" />
        </div>
      ))}


      {page*chunk < appConnectionsItems?.length && (
        <SectionMoreButton 
          title="Show more"
          onClick={() => setPage(page + 1)}
        />        
      )}      

      {/* <ConnectionsList appConnections={appConnectionsFiltered} app={app} chunk={chunk} /> */}
        
    </>
  )
}



const searchCompare = (searchText, itemText) => {
  return itemText?.toLowerCase()?.includes(searchText?.toLowerCase())
}


const getFilterCategories = (appConnections) => {
  // FILTER CONNECTIONS - get categories to filter  
  const categoriesList = appConnections?.map(item => ({ 
    id: item?.app?.primary_category?.id, 
    slug: item?.app?.primary_category?.slug, 
    name: item?.app?.primary_category?.name 
  }))?.filter(c => c?.slug)
  
  const categoriesUnique = Array.from(new Set(categoriesList.map(c => c.slug))).map(slug => {
    return categoriesList.find(c => c.slug === slug)
  })
  const filterCategories = categoriesUnique?.map(item => ({
    ...item, 
    count: categoriesList?.filter(c => c.slug === item.slug)?.length
  }))?.sort((a, b) => b.count-a.count)  // Full list of categories  
  return filterCategories    
}


const filterAppConnectionsByCategory = (appConnections, selectedCategory) => {
  // Used in several places, including page 
  const appConnectionsFilteredCats = (selectedCategory?.slug==='all' || !selectedCategory) ? appConnections : appConnections?.filter(c => c?.app?.primary_category?.slug === selectedCategory?.slug)  
  return appConnectionsFilteredCats
}



const getFilterSources = (appConnections, appSources, selectedCategory) => {
  const appConnectionsFilteredCats = filterAppConnectionsByCategory(appConnections, selectedCategory)
  const filterSources = appSources?.map(s => ({ 
    id: s?.id, 
    slug: s?.slug, 
    // name: s?.name, 
    name: s?.app?.name, 
    count: appConnectionsFilteredCats?.filter(c => c?.app?.sources?.map(x => x?.id)?.includes(s?.id))?.length
  }))?.filter(x => x?.count > 0)?.sort((a,b) => (b?.count - a?.count))
  return filterSources
}

const filterAppConnections = (appConnections, selectedCategory, selectedSource, searchAppText, dataApps) => {
  const appConnectionsFilteredCats = filterAppConnectionsByCategory(appConnections, selectedCategory)
  const appConnectionsFilteredSrc = (selectedSource?.slug==='all' || !selectedSource) ?  appConnectionsFilteredCats : appConnectionsFilteredCats?.filter(c => c?.app?.sources?.map(x => x?.id)?.includes(selectedSource?.id))
  const appConnectionsFiltered = searchAppText ? appConnectionsFilteredSrc?.filter(c => searchCompare(searchAppText, c?.app?.name)) : appConnectionsFilteredSrc    
  return appConnectionsFiltered
}



const getAppConnectionsItems = (app, appConnectionsFiltered, dataApps, searchAppText, selectedCategory, options) => {
  const { chunk } = options 

  let items = []

  let appConnectionsItems = appConnectionsFiltered?.map(appConnection => {
    const { app: appConnectionApp, ...rest } = appConnection  // rename app into connection

    const item = {
      app: {
        slug: app?.slug, 
        name: app?.name
      },
      connection: appConnectionApp, 
      ...rest

    }
    return item
  })

  if (appConnectionsItems?.length < chunk) {
    const currentAppsIDs = [app?.id, ...appConnectionsFiltered?.map(x => x?.app?.id)] 
    
    let syntheticApps: any = []
    syntheticApps = dataApps?.filter(x => !currentAppsIDs?.includes(x?.id))?.filter(x => searchCompare(searchAppText, x?.name))
    if (selectedCategory?.id) {
      syntheticApps = syntheticApps?.filter(x => x?.primary_category?.id === selectedCategory?.id)
      syntheticApps = syntheticApps?.map(({ 
        primary_category, 
        ...rest
      }) => ({
        primary_category: selectedCategory, 
        ...rest
      }))
    }
    
    const syntheticItems = syntheticApps?.map(x => ({
      app: {
        slug: app?.slug, 
        name: app?.name
      },
      connection: {
        id: x?.id, 
        slug: x?.slug, 
        name: x?.name, 
        image_updated_at: x?.image, // monkey
        primary_category: x?.primary_category // only id - "primary_category":{"id":8528}}
      },       
    }))
    appConnectionsItems = appConnectionsItems.concat(syntheticItems)
  }

  return appConnectionsItems
}